<div nz-row nzAlign="middle">
  <nz-select
    nz-col
    [(ngModel)]="selectValue"
    nzPlaceHolder="Choose"
    nzSize="large"
    class="search-select"
    [nzDropdownMatchSelectWidth]="true"
  >
    <nz-option nzValue="Design" nzLabel="Design"></nz-option>
    <nz-option nzValue="Equipment" nzLabel="Equipment"></nz-option>
  </nz-select>

  <form
    nz-form
    nz-col
    [formGroup]="searchForm"
    (ngSubmit)="lookup()"
    class="search-form"
    *ngIf="role$ | async"
  >
    <nz-form-item class="form-lookup">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            nz-input
            placeholder="{{ selectValue }}"
            class="search-input"
            name="designInput"
            formControlName="designInput"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <button type="submit" nz-button nzType="link" class="button-lookup">
            <i nz-icon nzType="search"></i>
          </button>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
